import { MutableRefObject, createContext } from 'react';
// 常量
import { EdiTableDispatchType, IEdiTablePayload } from '../interface';
import { FormInstance } from 'antd/lib/form';

export interface IBaseEdiTableContext {
  dataSource?: any[];
  forms?: MutableRefObject<(FormInstance | undefined)[]>;
  editableRef: HTMLDivElement | null;
}
export interface IEdiTableContext extends IBaseEdiTableContext {
  dispatchEdiTable: (
    type: EdiTableDispatchType,
    payload: IEdiTablePayload,
  ) => void;
}
export default createContext<IEdiTableContext>({
  editableRef: null,
  dispatchEdiTable: () => {},
});
